import React from 'react';

import ReactDOM from 'react-dom';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import { ExecutionDialog } from '@qality/common-components';

export default {
  openTestCaseExecutionDialog(testCaseId: string, testCaseName: string): void {
    const modalElem: any = document.getElementById(
      'com_soldevelo_apps_test-management_dialog'
    );
    ReactDOM.render(
      <ExecutionDialog
        testCaseId={testCaseId}
        testCaseName={testCaseName}
        onClose={onClose}
      />,
      modalElem
    );
  },
};

const onClose = () => {
  const remove: Element = document.querySelector(
    '#com_soldevelo_apps_test-management_dialog'
  );
  ReactDOM.unmountComponentAtNode(remove);
};
